var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3332 117.333H21.3332C18.5042 117.333 15.7911 116.209 13.7907 114.208C11.7903 112.208 10.6665 109.495 10.6665 106.666V69.3327C10.6665 66.5037 11.7903 63.7906 13.7907 61.7902C15.7911 59.7898 18.5042 58.666 21.3332 58.666H37.3332M74.6665 47.9994V26.666C74.6665 22.4226 72.9808 18.3529 69.9802 15.3523C66.9796 12.3517 62.91 10.666 58.6665 10.666L37.3332 58.666V117.333H97.4932C100.066 117.362 102.562 116.46 104.522 114.794C106.482 113.128 107.774 110.81 108.16 108.266L115.52 60.266C115.752 58.7373 115.649 57.1763 115.218 55.6914C114.787 54.2064 114.038 52.8329 113.023 51.6661C112.008 50.4993 110.752 49.567 109.342 48.9338C107.931 48.3007 106.399 47.9818 104.853 47.9994H74.6665Z",
    stroke: "currentColor",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbsUp.1b91ac3d170cc73811face2cd8811b4b.svg";
export { ForwardRef as ReactComponent };